import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import getLocalized from 'utils/get-localized';
import getImagePath from 'utils/get-image-path';
import scaleSize from 'utils/scale-size';
import { StyledIconUp, StyledIconDown } from '../StyledComponents';

const StyledNavigationTip = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  font-size: ${scaleSize(24)}px;
  color: ${({ theme }) => theme.mainTextColor};
  top: ${({ top }) => top}px;
  left: ${scaleSize(36)}px;
`;

const StyledNavigationChannelLogo = styled.div`
  opacity: 0.75;
  width: ${scaleSize(60)}px;
  height: ${scaleSize(60)}px;
  margin-right: ${scaleSize(20)}px;
  background: url(${({ src }) => src}) no-repeat center;
`;

const HeaderNavigationTip = ({ channel, direction, disableChannelChange }) => {
  if (!channel) return null;
  if (disableChannelChange) return null;

  const top = direction === 'up' ? -105 : 210;

  return (
    <>
      {direction === 'down' && <StyledIconDown />}
      <StyledNavigationTip top={scaleSize(top)}>
        <StyledNavigationChannelLogo src={getImagePath(channel.logoUrl, scaleSize(60), scaleSize(60))} />
        {channel.currentProgram && (
          <div>{getLocalized(channel.currentProgram.titles, channel.currentProgram.title)}</div>
        )}
      </StyledNavigationTip>
      {direction === 'up' && <StyledIconUp />}
    </>
  );
};

HeaderNavigationTip.propTypes = {
  channel: PropTypes.object.isRequired,
  direction: PropTypes.oneOf(['up', 'down']).isRequired,
};

export default HeaderNavigationTip;
